module.exports = __webpack_public_path__ + "static/media/game-exitbutton.71ad3a20.png";